/**
 * The lit finish on a rig figure's frame (lane C0-PLAY, user 2026-10-10: "ใส่เส้นขอบและแสงเงาแบบในรูป"): one
 * post-pass over the whole composed frame, after every piece is laid in (rig/sets.ts `frameOf`), so every
 * figure on the rig path (the player, people, the cards' live frames) gets it from one place.
 *
 * It is the finish the figures had in the user's reference picture (the 2026-10-04 client, commit 9fbc89f0:
 * `outline(litShade(c))` in sprites.ts), brought to the rig's double resolution:
 * - `litShade`: banded form light from the upper right (a lit rim on the right and top, shade on the left,
 *   underneath and toward the feet), its edges one art pixel deep;
 * - `outline`: a dark ink outline (#18121e, a deep plum) one art pixel wide (one ring per canvas pixel of it).
 */
import { figOutline } from '../figureOutline';
import { ctx2d, litShade, resOf } from '../pixel';
import { cleanSprite } from '../truepx/clean';
import { truePxFigures } from '../truepx/flags';

/** Off brings back the flat finish (pieces as drawn, no light or outline). */
export const LIT_FINISH = true;

/** The whole finish on a full (uncropped) frame: light, then the outline. */
export function litFinish(c: HTMLCanvasElement): HTMLCanvasElement {
  if (!LIT_FINISH) return c;
  const R = resOf(c);
  litShade(c, R);
  figOutline(c, undefined, R);
  // Lane C0-TRUEPX-GAME: the true-pixel clean-up (render/truepx/), when this page draws figures that way.
  if (truePxFigures()) {
    const g = ctx2d(c);
    const img = g.getImageData(0, 0, c.width, c.height);
    cleanSprite(new Uint32Array(img.data.buffer), c.width, c.height, R, true);
    g.putImageData(img, 0, 0);
  }
  return c;
}
